export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10611.a178685e.jpg";